var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-phone-input',{staticStyle:{"display":"flex","gap":"20px"},attrs:{"dense":"","filled":"","rules":_vm.rules,"enableSearchingCountry":false},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.iso2)+"+"+_vm._s(item.dialCode)+" ")]}},{key:"country-name",fn:function(ref){
var country = ref.country;
return [_c('strong',[_vm._v("+"+_vm._s(country.dialCode))]),_vm._v(" "+_vm._s(country.name)+" ")]}}]),model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})}
var staticRenderFns = []

export { render, staticRenderFns }